import { render, staticRenderFns } from "./Fraction.vue?vue&type=template&id=260216d2&"
import script from "./Fraction.vue?vue&type=script&lang=js&"
export * from "./Fraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports